import { render, staticRenderFns } from "./NotaAvulsaListView.vue?vue&type=template&id=85fe36f0"
import script from "./NotaAvulsaListView.vue?vue&type=script&lang=js"
export * from "./NotaAvulsaListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports